// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__BPxIp","addWidgetButton":"Header_addWidgetButton__3EiaY","dashboardTabs":"Header_dashboardTabs__3SwuJ","active":"Header_active__Xbegk"};